import React from "react";
import { Link } from "react-router-dom";
import { Stethoscope } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="mt-20 bg-[hsl(var(--ld-footer))] text-[hsl(var(--ld-footer-fg))]">
      <div className="mx-auto max-w-[1280px] px-4 lg:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            {settings.logo_url ? (
              <img src={settings.logo_url} alt={settings.brand_name} className="h-9 w-9 rounded-lg object-cover" />
            ) : (
              <span className="h-9 w-9 rounded-lg bg-primary text-primary-foreground grid place-items-center">
                <Stethoscope size={20} strokeWidth={2} />
              </span>
            )}
            <span className="font-display text-lg font-bold">{settings.brand_name}.in</span>
          </div>
          <p className="mt-4 text-sm text-white/70 max-w-xs">
            {settings.footer_tagline}
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold tracking-wide uppercase text-white/80">For Patients</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li><Link to="/doctors/pune" className="hover:text-white">Find a doctor</Link></li>
            <li><Link to="/specialties" className="hover:text-white">Browse specialties</Link></li>
            <li><Link to="/patient/login" className="hover:text-white">Patient login</Link></li>
            <li><Link to="/about#how" className="hover:text-white">How it works</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold tracking-wide uppercase text-white/80">For Doctors</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li><Link to="/list-your-practice" className="hover:text-white">List your practice</Link></li>
            <li><Link to="/about#verify" className="hover:text-white">Verification process</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact support</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold tracking-wide uppercase text-white/80">Company</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white">Terms &amp; Conditions</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1280px] px-4 lg:px-6 py-6 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between text-xs text-white/60">
          <p>© {new Date().getFullYear()} {settings.brand_name}.in · Owned &amp; operated by <span className="text-white font-semibold">{settings.founder_name}</span>. All rights reserved.</p>
          <p className="max-w-2xl">
            Medical disclaimer: LocalDoctor helps users discover doctors and clinics. Medical information
            and treatment decisions should always be discussed directly with a qualified medical professional.
          </p>
        </div>
      </div>
    </footer>
  );
}
